export default __webpack_public_path__ + "static/media/rainbow.901692a8.png";